export default "__VITE_PUBLIC_ASSET__2d4a21d6__"